import { forwardRef, useEffect, useRef, useState } from "react";

const ListBoxCustom = forwardRef((props, ref) => {
  const { children, ...other } = props;
  const [indicatorStyle, setIndicatorStyle] = useState({
    top: 0,
    height: 0,
    opacity: 0,
  });
  const listRef = useRef(null);
  useEffect(() => {
    const updateIndicator = () => {
      if (!listRef.current) return;
      const focusedElement = listRef.current.querySelector(".Mui-focused");

      if (focusedElement) {
        setIndicatorStyle({
          top: focusedElement.offsetTop,
          height: focusedElement.offsetHeight,
          opacity: 1,
        });
      } else {
        setIndicatorStyle((prev) => ({ ...prev, opacity: 0 }));
      }
    };
    const observer = new MutationObserver(updateIndicator);
    if (listRef.current) {
      observer.observe(listRef.current, {
        attributes: true,
        subtree: true,
        attributeFilter: ["class"],
      });
    }
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} {...other}>
      <ul
        ref={listRef}
        style={{ position: "relative", padding: 0, marginInline: 9 }}
      >
        <div
          style={{
            borderRadius: 8,
            position: "absolute",
            left: 0,
            width: "100%",
            backgroundColor: "rgba(33, 150, 243, 0.1)",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            pointerEvents: "none",
            zIndex: 0,
            ...indicatorStyle,
          }}
        />
        {children}
      </ul>
    </div>
  );
});

export default ListBoxCustom;
